import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-vincular-promocao-lote-clientes',
  templateUrl: './vincular-promocao-lote-clientes.component.html',
  styleUrls: ['./vincular-promocao-lote-clientes.component.scss', '../../styles/estilo.padrao.scss']
})
export class VincularPromocaoLoteClientesComponent implements OnInit {

  uid;
  bPermissaoEditar: boolean = false;
  bBotaoAlterar: boolean = true;
  bExibirClientes: boolean = false;
  displayedColumnsListaClientes: string[] = ['select', 'Nome', 'Cidade', 'UF', 'StatusString'];
  aClientes: any[] = [];
  aGruposPromocionais: any[] = [];
  grupoSelecionado;
  clientesSource;
  sProdutos;
  $conexao;

  porcentagemDesconto: number = 0;
  quantidadeMinima: number = 1;

  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
  ) {
    this.uid = localStorage.getItem('uid');

    this.spinner.show('vincular-promocao-lote');

    //Validar Permissões
    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.usuarioService.getFuncionario(this.uid).subscribe(dados => {
          if (dados) {
            const dadosFuncionario: any = dados;
            this.bPermissaoEditar = dadosFuncionario.Permissoes.Alterar.Clientes;
            !this.bPermissaoEditar ? this.bBotaoAlterar = false : true;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.$conexao = null;
  }

  ngOnInit(): void {
    this.usuarioService.getGruposPromocoes().pipe(take(1)).subscribe(snap => {
      let auxGrupos = [];
      let dados;
      let i;
      let sAuxNomeProdutos = '';
      this.aGruposPromocionais = [];

      if (snap.length > 0) {
        snap.forEach((item, index) => {
          dados = item.payload.val();

          sAuxNomeProdutos = '';
          for (i = 0; i < dados.Produtos.length; i++) {
            sAuxNomeProdutos = sAuxNomeProdutos + dados.Produtos[i].Nome + '; ';
          }

          auxGrupos.push({
            ID: item.key,
            Status: dados.Status,
            Nome: dados.Nome,
            Produtos: dados.Produtos,
            ProdutosString: sAuxNomeProdutos,
            QuantidadeMinima: dados.QuantidadeMinima
          });

        });
      }

      this.aGruposPromocionais = auxGrupos;
      setTimeout(() => this.spinner.hide('vincular-promocao-lote'), 300);
    });
  }

  carregarClientes() {
    if (this.grupoSelecionado) {
      this.spinner.show('vincular-promocao-lote');
      this.aClientes = [];
      this.clientesSource = null;

      this.$conexao = this.usuarioService.getClientes().pipe(take(1)).subscribe(snap => {

        if (snap.length > 0) {
          let auxClientes: any[] = [];
          this.aClientes = [];
          var dados;

          snap.forEach((item, index) => {
            dados = item.payload.val();

            auxClientes.push({
              ID: item.key,
              StatusString: dados.Status ? 'Ativo' : 'Desativado',
              Nome: dados.Nome,
              Email: dados.Email,
              Cidade: dados.Cidade,
              UF: dados.UF,
              GruposPromocionais: dados.GruposPromocionais,
              bAdicionarRemover: false,
              idPromocao: false
            });
          });

          this.aClientes = auxClientes;
          this.inicializarDados();
        } else {
          this.toastr.error("Não foi possível localizar clientes!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => this.spinner.hide('vincular-promocao-lote'), 300);
        }
      });
    } else
      this.toastr.warning("Selecione um grupo!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });

  }

  inicializarDados() {
    this.bExibirClientes = false;

    this.sProdutos = this.grupoSelecionado.ProdutosString;
    this.quantidadeMinima = this.grupoSelecionado.QuantidadeMinima

    let auxAClientes = this.aClientes;

    this.clientesSource = new MatTableDataSource(auxAClientes);
    setTimeout(() => this.clientesSource.paginator = this.paginator, 50);
    this.selection = new SelectionModel<any>(true, []);
    this.selection.clear();

    //this.clientesSource.paginator = this.paginator;

    let position;
    let auxDados;
    let idPromocao;
    for (let i = 0; i < auxAClientes.length; i++) {
      position = -1;
      idPromocao = false;

      if (auxAClientes[i].GruposPromocionais) {
        for (let l = 0; l < auxAClientes[i].GruposPromocionais.length; l++) {
          auxDados = auxAClientes[i].GruposPromocionais[l];
          if (auxDados) {
            if (auxDados.IDGrupoDesconto === this.grupoSelecionado.ID) {
              position = i;
              idPromocao = i;
              break;
            }
          }
        };
      }

      if (position != -1) {
        //Selecionar linha do cliente
        this.selection.toggle(auxAClientes[i]);
        auxAClientes[i].bAdicionarRemover = true;
        auxAClientes[i].idPromocao = idPromocao;
      } else {
        auxAClientes[i].bAdicionarRemover = false;
        auxAClientes[i].idPromocao = idPromocao;
      }
    }

    this.aClientes = auxAClientes;
    this.bExibirClientes = true;
    setTimeout(() => this.spinner.hide('vincular-promocao-lote'), 300);
  }

  async salvar() {
    const porcentagem = this.porcentagemDesconto / 100;

    if (this.quantidadeMinima > 0 && this.quantidadeMinima <= 100000) {
      if (porcentagem >= 1 && porcentagem <= 50) {
        this.spinner.show('default');

        const auxSelection: any = this.selection.selected;

        let auxAClientes = [];
        const auxClientes = this.aClientes;
        for (let o = 0; o < auxClientes.length; o++) {
          auxAClientes.push({
            GruposPromocionais: auxClientes[o].GruposPromocionais ? auxClientes[o].GruposPromocionais : [{}],
            ID: auxClientes[o].ID,
            bAdicionarRemover: auxSelection.findIndex(x => x.ID === auxClientes[o].ID) === -1 ? false : true,
            idPromocao: auxClientes[o].idPromocao,
          })
        }

        try {
          const resp = await Promise.all(auxAClientes.map(async (cliente) => {
            if (cliente) {

              let mapGruposPromocionais = cliente.GruposPromocionais;
              let index;

              try {
                index = mapGruposPromocionais ? mapGruposPromocionais.findIndex(x => x.IDGrupoDesconto === this.grupoSelecionado.ID) : -1;
              } catch (error) {
                index - 1;
              }

              if (cliente.bAdicionarRemover) {

                if (index != -1) {
                  mapGruposPromocionais.splice(index, 1);
                }
                mapGruposPromocionais.push({
                  IDGrupoDesconto: this.grupoSelecionado.ID,
                  Nome: this.grupoSelecionado.Nome,
                  QuantidadeMinima: this.grupoSelecionado.QuantidadeMinima,
                  PorcentagemDesconto: porcentagem,
                  Produtos: this.grupoSelecionado.Produtos,
                  ProdutosString: this.grupoSelecionado.ProdutosString
                });
                return await this.usuarioService.updateGrupoPromocionalUsuario(cliente.ID, mapGruposPromocionais).then(resp => {
                  return;
                });
              } else {

                if (!cliente.bAdicionarRemover) {
                  if (index != -1) {
                    mapGruposPromocionais.splice(index, 1);
                  }
                }

                // if (JSON.stringify(mapGruposPromocionais) !== JSON.stringify(this.aClientes[this.aClientes.findIndex(x => x.ID === cliente.ID)].GruposPromocionais)) {
                //Remove e insere até os que não foram modificados. Criar um sistema para validar os não modificados e não atualizá-los
                if (JSON.stringify(mapGruposPromocionais)) {
                  console.log('GruposPromocionais é diferente');
                  return await this.usuarioService.updateGrupoPromocionalUsuario(cliente.ID, mapGruposPromocionais).then(resp => {
                    return;
                  });
                } else
                  return;
              }
            }

          })).then(resp => {

            this.toastr.success('Promoção atualizada nos clientes!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            this.usuarioService.setLog("Lista de promoção atualizada em demanda", this.aClientes, this.uid);
            this.spinner.hide('default');
            this.cancelar();
          });

        } catch (e) {
          console.log(e)
          this.spinner.hide('default');
          this.usuarioService.setLog("Erro ao atualizar a lista de promoção atualizada em demanda. Erro: " + e, this.aClientes, this.uid);
          this.cancelar();
        }

      } else {
        this.toastr.error("Informe a porcentagem entre 1% a 50,00%!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      }
    } else {
      this.toastr.error("Informe uma quantidade entre 1 e 100.000", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (this.clientesSource.paginator) {
      this.clientesSource.paginator.firstPage();
    }

    this.clientesSource.filter = filterValue.trim().toLowerCase();
  }

  cancelar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() => {
      setTimeout(() => {
        this.router.navigate(["/pages/vincular-promocao-lote-clientes"]);
      }, 150);
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    try {
      const numSelected = this.selection.selected.length;
      const numRows = this.clientesSource.data.length;
      return numSelected === numRows;
    } catch (error) {
      return false;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.clientesSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

}
